import { render, staticRenderFns } from "./SquareImage.vue?vue&type=template&id=49ef3190&scoped=true&name=square-image&"
import script from "./SquareImage.vue?vue&type=script&lang=js&"
export * from "./SquareImage.vue?vue&type=script&lang=js&"
import style0 from "./SquareImage.vue?vue&type=style&index=0&id=49ef3190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ef3190",
  null
  
)

export default component.exports